import React, { useState } from 'react';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { GlobalDropDown } from '../components/GlobalDropDown';
import GlobalDialog from '../components/GlobalDialog';
import Message from './Message/Message';
function MassOrderEdit({
  callback,
  massiveEditDialog,
  setMassiveEditDialog,
}: {
  callback: (data: any) => void;
  massiveEditDialog: boolean;
  setMassiveEditDialog: (val: boolean) => void;
}) {
  const [description, setDescription] = useState();
  // const [trade_id, setTradeId] = useState();
  const [start_date, setStartDate] = useState();
  const [statusCode, setStatusCode] = useState();
  const [statusId, setStatusId] = useState();
  const [priority_code, setPriorityCode] = useState();
  const [priorityId, setPriorityId] = useState();
  const [typeCode, setTypeCode] = useState();
  const [typeId, setTypeId] = useState();
  const [resp, setResp] = useState();
  const [teamCode, setTeamCode] = useState();
  const [section, setSection] = useState();
  const [reference, setReference] = useState();
  const [prontoReferenceId, setProntoReferenceId] = useState();
  const [prontoReferenceCode, setProntoReferenceCode] = useState();
  const [reason, setReason] = useState();
  const erpTypeName = 'MEX';
  let ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  return (
    <>
      <GlobalDialog
        showDialog={massiveEditDialog}
        setShowDialog={(val) => setMassiveEditDialog(val)}
        header='Edit'
        width={'600px'}
        hideDoneButton={true}
        buttons={[
          {
            buttonModel: { content: 'Cancel' },
            click: () => setMassiveEditDialog(false),
          },
          {
            buttonModel: { content: 'Apply' },
            click: () => {
              const dataOrder: any = {
                description,
                scheduled_start_date: start_date,
                status_code: statusCode,
                reason: reason,
                status_id: statusId,
                priority_code,
                priority_id: priorityId,
                type_code: typeCode,
                type_id: typeId,
                order_resp_code: resp,
                team_code: teamCode,
                order_section_code: section,
                site_details_1:
                  ERP_TYPE === erpTypeName ? reference : prontoReferenceId,
              };

              const dataOperations: any = {
                priority: priority_code,
                responsibility: resp,
                workOrderType: typeCode,
                longDescription: description,
                section: section,
              };
              Object.keys(dataOrder).forEach(
                (key) => dataOrder[key] === undefined && delete dataOrder[key]
              );
              Object.keys(dataOperations).forEach(
                (key) =>
                  dataOperations[key] === undefined &&
                  delete dataOperations[key]
              );
              let isEmpty =
                Object.keys(dataOrder).length === 0 &&
                dataOrder.constructor === Object;
              if (isEmpty) {
                Message.error('Please fill at least one field');
                return;
              }
              callback({ dataOrder, dataOperations });
              setMassiveEditDialog(false);
            },
          },
        ]}
      >
        <div className='col-md-12'>
          <div className='col-md-12'>
            <div className='col-md-12'>
              <TextBoxComponent
                placeholder='Description'
                floatLabelType='Auto'
                value={description}
                onChange={(e: any) => setDescription(e.target.value)}
              />
            </div>
          </div>
          <div className='col-md-12'>
            <div className='col-md-6'>
              <DateTimePickerComponent
                placeholder='Start Date'
                floatLabelType='Always'
                format={'dd/MM/yyyy HH:mm a'}
                value={start_date}
                onChange={(e: any) => {
                  setStartDate(e.target.value);
                }}
              />
            </div>
            {ERP_TYPE === 'PRONTO' ? (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-reference-pronto'
                  field= {{ value: 'value', text: 'value' }}
                  url='global-filter?where=workorders$reference$isEnabled€1'
                  placeHolder='Reference'
                  value={prontoReferenceId}
                  onChange={(e: any) => {
                    setProntoReferenceCode(e.target.itemData?.description);
                    setProntoReferenceId(e.target.value);
                  }}
                  floatLabelType='Always'
                />
              </div>
            ) : (
              <></>
            )}
             {ERP_TYPE === 'PRONTO' ? (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-reason-pronto'
                  field= {{ value: 'value', text: 'value' }}
                  url='global-filter?where=workorders$reason$isEnabled€1'
                  placeHolder='Hold Reason'
                  value={reason}
                  onChange={(e: any) => {
                    setReason(e.target.value);
                  }}
                  floatLabelType='Always'
                />
              </div>
            ) : (
              <></>
            )}
            {ERP_TYPE === 'PRONTO' ? (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-resp'
                  field={{ value: 'value', text: 'description' }}
                  //url='system-config?where=P2'
                  url='global-filter?where=workorders$responsibility$isEnabled€1'
                  placeHolder='Responsibility'
                  value={resp}
                  onChange={(e: any) => setResp(e.target.value)}
                  floatLabelType='Always'
                />
              </div>
            ) : (
              <></>
            )}
            {ERP_TYPE === erpTypeName ? (
              <div className='col-md-6'>
                <TextBoxComponent
                  placeholder='Reference'
                  floatLabelType='Auto'
                  value={reference}
                  onChange={(e: any) => setReference(e.target.value)}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className='col-md-12'>
            <div className='col-md-6'>
              <GlobalDropDown
                id='mo-team'
                field={{ text: 'team_code', value: 'team_code' }}
                url='team'
                placeHolder='Teams'
                value={teamCode}
                onChange={(e: any) => setTeamCode(e.target.value)}
                floatLabelType='Always'
              />
            </div>
            <div className='col-md-6'>
              <GlobalDropDown
                id='mo-status'
                field={{ value: 'value', text: 'alias' }}
                url='global-filter?where=workorders$status$isEnabled€1'
                placeHolder='Status'
                value={statusId}
                onChange={(e: any) => {
                  setStatusCode(e.target.itemData?.description);
                  setStatusId(e.target.value);
                }}
                floatLabelType='Always'
              />
            </div>
          </div>

          <div className='col-md-12'>
            <div className='col-md-6'>
              <GlobalDropDown
                id='mo-type'
                field={{ value: 'value', text: 'alias' }}
                //field={{ value: 'sys_tbl_code', text: 'sys_description' }}
                //url='system-config?where=P3'
                url='global-filter?where=workorders$type$isEnabled€1'
                placeHolder='Type'
                value={typeId}
                onChange={(e: any) => {
                  setTypeCode(e.target.itemData?.description);
                  setTypeId(e.target.value);
                }}
                floatLabelType='Always'
              />
            </div>
            <div className='col-md-6'>
              <GlobalDropDown
                id='mo-priority'
                field={{ value: 'value', text: 'alias' }}
                url='global-filter?where=workorders$priority$isEnabled€1'
                placeHolder='Priority'
                value={priority_code}
                onChange={(e: any) => {
                  setPriorityId(e.target.value);
                  setPriorityCode(e.target.value);
                }}
                floatLabelType='Always'
              />
            </div>
          </div>
          {ERP_TYPE === 'PRONTO' ? (
            <div className='col-md-12'>
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-section'
                  field={{ value: 'sys_tbl_code', text: 'sys_description' }}
                  //url='system-config?where=N4'
                  url='system-config?where=N4'
                  placeHolder='Section'
                  value={section}
                  onChange={(e: any) => setSection(e.target.value)}
                  floatLabelType='Always'
                />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </GlobalDialog>
    </>
  );
}

export default MassOrderEdit;
